import type { ServiceEditorFormData } from '@/features/services/types'

export function calculateSeoScore(formData: ServiceEditorFormData): number {
  let score = 0
  if (formData.title.length >= 30 && formData.title.length <= 60) score += 20
  if (formData.meta_description && formData.meta_description.length >= 120 && formData.meta_description.length <= 160) {
    score += 20
  }
  if (formData.description && formData.description.length >= 100) score += 15
  if (formData.content && formData.content.length >= 300) score += 15
  if (formData.hero_image) score += 10
  if (formData.benefits.length >= 3) score += 10
  if (formData.process_steps.length >= 3) score += 10
  return score
}
